// JsFromRoutes CacheKey 68c4985120c99f65402efd83bc4048c6
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@corp/services/api'

export default {
  toggle: /* #__PURE__ */ definePathHelper('post', '/admin/consumer/places/:place_id/listings/toggle'),
}
